import store from '@/store'
import router from '@/router'
import { geolocation } from '@/plugins/geolocation'
import i18n from './i18n'
const { t } = i18n.global

async function mainMessageMethodListener(event) {
  await store.dispatch('restorePreviousSessionIfActive')
  await getInfoDeviceAndCreateSession(store.state.common.deviceId)

  await geolocation()

  const message = event.data
  if (message.action === 'showCommercial') {
    store.commit('setShowPlace', true)
    store.commit('setPlace', getNotificationZoneLocale(message.place))
    store.commit('setImageMapPlace', getNotificationZoneMapImage(message.place))
    router.push('Commercial')
  } else if (message.action === 'setPlace') {
    store.commit('setPlace', getNotificationZoneLocale(message.place))
    store.commit('setImageMapPlace', getNotificationZoneMapImage(message.place))
  }
}

const getInfoDeviceAndCreateSession = async (deviceId) => {
  store.commit('setDeviceId', deviceId)
  store.dispatch('getDeviceInfo')
  await store.dispatch('createSession')

  if (!store.getters['getExperienceTypes']) store.dispatch('getExperienceTypes')
}

//Recuperar NOMBRE zona recibida en la notificación
function getNotificationZoneLocale(key) {
  if (key) {
    let zoneKey
    for (let [k, v] of mapZoneNotification) {
      if (!zoneKey) {
        if (key.toLowerCase().includes(k.toLowerCase())) {
          zoneKey = k
        }
      }
    }

    return mapZoneNotification.has(zoneKey)
      ? t(mapZoneNotification.get(zoneKey))
      : key
  } else return key
}

let mapZoneNotification = new Map()
mapZoneNotification.set('Zona A', 'zones.entertainment')
mapZoneNotification.set('Zona B', 'zones.devices')
mapZoneNotification.set('Zona C', 'zones.staircase')
mapZoneNotification.set('Zona G', 'zones.blue')
mapZoneNotification.set('Zona R', 'zones.blue')
mapZoneNotification.set('GURU', 'zones.blue')
mapZoneNotification.set('ST', 'zones.blue')
mapZoneNotification.set('SAM', 'zones.help')
mapZoneNotification.set('XIA', 'zones.help')
mapZoneNotification.set('APP', 'zones.help')
mapZoneNotification.set('MIX', 'zones.help')
mapZoneNotification.set('DISP NORTE', 'zones.help')
mapZoneNotification.set('DISP SUR', 'zones.help')
mapZoneNotification.set('GAMING', 'zones.help')
mapZoneNotification.set('ENTRE', 'zones.help')
mapZoneNotification.set('MESA TRÉBOL', 'zones.help')
mapZoneNotification.set('ECO', 'zones.tech')
mapZoneNotification.set('360', 'zones.energy')
mapZoneNotification.set('CONEC', 'zones.connectivity')
mapZoneNotification.set('ELECT', 'zones.appliances')
mapZoneNotification.set('SEGU', 'zones.security')
mapZoneNotification.set('RECOMPRA', 'zones.management')

//Recuperar IMAGEN MAPA según la zona recibida en la notificación
function getNotificationZoneMapImage(key) {
  if (key) {
    let zoneKey

    for (let [k, v] of mapZoneImageMap) {
      if (!zoneKey) {
        if (key.toLowerCase().includes(k.toLowerCase())) {
          zoneKey = k
        }
      }
    }

    return mapZoneImageMap.has(zoneKey)
      ? mapZoneImageMap.get(zoneKey)
      : undefined
  } else return key
}

let mapZoneImageMap = new Map()
mapZoneImageMap.set('Zona A', 'cardMaps/map0_3.png')
mapZoneImageMap.set('Zona B', 'cardMaps/map0_5.png')
mapZoneImageMap.set('Zona C', 'cardMaps/map0_Escalera.png')
mapZoneImageMap.set('Zona G', 'cardMaps/map1_3.png')
mapZoneImageMap.set('Zona R', 'cardMaps/map1_3.png')
mapZoneImageMap.set('GURU', 'cardMaps/map1_3.png')
mapZoneImageMap.set('ST', 'cardMaps/map1_3.png')
mapZoneImageMap.set('SAM', 'cardMaps/map0_5.png')
mapZoneImageMap.set('XIA', 'cardMaps/map0_5.png')
mapZoneImageMap.set('APP', 'cardMaps/map0_5.png')
mapZoneImageMap.set('MIX', 'cardMaps/map0_5.png')
mapZoneImageMap.set('DISP NORTE', 'cardMaps/map0_4.png')
mapZoneImageMap.set('DISP SUR', 'cardMaps/map0_5.png')
mapZoneImageMap.set('GAMING', 'cardMaps/map1_4.png')
mapZoneImageMap.set('ENTRE', 'cardMaps/map0_3.png')
mapZoneImageMap.set('MESA TRÉBOL', 'cardMaps/map0_4.png')
mapZoneImageMap.set('360', 'cardMaps/map0_8.png')
mapZoneImageMap.set('CONEC', 'cardMaps/map0_4.png')
mapZoneImageMap.set('ELECT', 'cardMaps/map0_7.png')
mapZoneImageMap.set('SEGU', 'cardMaps/map0_6.png')
mapZoneImageMap.set('RECOMPRA', 'cardMaps/map1_3.png')

export default mainMessageMethodListener
